import React from 'react';

export default function ownerNameTemplate(data) {
  const { ownerFirstName, ownerLastName } = data;
  return <div>{`${ownerFirstName} ${ownerLastName}`}</div>;
}
